import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Constants } from '@constants';
import { environment} from '@env';
import { FeedbackSurvey, FeedbackSurveyResponse } from '@models';

import { HttpHelper } from '@shared/util/httpHelper';

@Injectable()
export class FeedbackHttp {

    private baseUrl: string ='';

    constructor( 
        private http: HttpClient ,
        private httpHelper: HttpHelper) {
    }

    getFeedbackSurvey = (domainId: string): Observable<FeedbackSurvey> => { 
        return this.http.get<FeedbackSurvey>(
            this.baseUrl + Constants.ServiceUrls.GetFeedbackSurvey.replace('{domainId}', domainId))
        .pipe(
            // retry(3), // retry a failed request up to 3 times
            catchError((err) => this.httpHelper.handleError(err)) // then handle the error
          );
    }

    postFeedbackSurvey = (surveyResponse: FeedbackSurveyResponse): 
    Observable<FeedbackSurvey> => {

        return this.http.post<FeedbackSurvey>(
            this.baseUrl + Constants.ServiceUrls.PostFeedbackSurvey, 
            surveyResponse, 
            {headers: this.httpHelper.headers})
        .pipe(
            // retry(3), // retry a failed request up to 3 times
            catchError((err) => this.httpHelper.handleError(err)) // then handle the error
          );
    }
}
